var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var getSizeAndPosition = function (size, position, open) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var widths = {
        small: 400,
        medium: 700,
        large: 1240,
        xlarge: 1280,
    };
    var sizes = {
        small: (_a = {
                maxWidth: widths[size]
            },
            _a[position] = widths[size] * -1,
            _a.width = '100%',
            _a["@media ".concat(mobile(700))] = (_b = {
                    maxWidth: '100%'
                },
                _b[position] = open ? 0 : '-100%',
                _b.width = '100%',
                _b),
            _a),
        medium: (_c = {
                maxWidth: widths[size]
            },
            _c[position] = widths[size] * -1,
            _c.width = '100%',
            _c["@media ".concat(mobile(860))] = (_d = {
                    maxWidth: '100%'
                },
                _d[position] = open ? 0 : '-100%',
                _d.width = '100%',
                _d),
            _c),
        large: (_e = {
                maxWidth: widths[size]
            },
            _e[position] = '-65%',
            _e.width = '65%',
            _e["@media ".concat(mobile(860))] = (_f = {
                    maxWidth: '100%'
                },
                _f[position] = open ? 0 : '-100%',
                _f),
            _e),
        xlarge: (_g = {
                maxWidth: '100%'
            },
            _g[position] = widths[size] * -1,
            _g.width = widths[size],
            _g["@media ".concat(mobile(1280))] = (_h = {
                    maxWidth: '100%'
                },
                _h[position] = open ? 0 : '-100%',
                _h),
            _g),
    };
    return __assign({}, sizes[size]);
};
export var getOpen = function (position) {
    var _a;
    return (_a = {}, _a[position] = 0, _a);
};
// Left
export var smallLeftOpen = getSizeAndPosition('small', 'left', true);
export var smallLeftClosed = getSizeAndPosition('small', 'left', false);
export var mediumLeftOpen = getSizeAndPosition('medium', 'left', true);
export var mediumLeftClosed = getSizeAndPosition('medium', 'left', false);
export var largeLeftOpen = getSizeAndPosition('large', 'left', true);
export var largeLeftClosed = getSizeAndPosition('large', 'left', false);
export var xlargeLeftOpen = getSizeAndPosition('xlarge', 'left', true);
export var xlargeLeftClosed = getSizeAndPosition('xlarge', 'left', false);
// Right
export var smallRightOpen = getSizeAndPosition('small', 'right', true);
export var smallRightClosed = getSizeAndPosition('small', 'right', false);
export var mediumRightOpen = getSizeAndPosition('medium', 'right', true);
export var mediumRightClosed = getSizeAndPosition('medium', 'right', false);
export var largeRightOpen = getSizeAndPosition('large', 'right', true);
export var largeRightClosed = getSizeAndPosition('large', 'right', false);
export var xlargeRightOpen = getSizeAndPosition('xlarge', 'right', true);
export var xlargeRightClosed = getSizeAndPosition('xlarge', 'right', false);
export var openLeft = getOpen('left');
export var openRight = getOpen('right');
export var drawer = {
    background: '#ffffff',
    bottom: 0,
    boxShadow: '0 4px 12px rgba(75, 88, 99, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1280,
    outline: 0,
    position: 'fixed',
    right: '-65%',
    top: 0,
    transition: 'left .4s cubic-bezier(.645,.045,.355,1),right .4s cubic-bezier(.645,.045,.355,1)',
    width: '65%',
    zIndex: 900,
    '@media screen and (prefers-reduced-motion: reduce)': {
        transition: 'none',
    },
};
export var drawerNested = __assign(__assign({}, drawer), { zIndex: 902 });
export var drawerPadding = {
    padding: 32,
};
export var content = {
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'relative',
    p: {
        color: '#000000',
    },
};
export var overlay = {
    label: 'overlay',
    bottom: 0,
    content: '""',
    cursor: 'default',
    height: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    transition: 'background 0.3s linear',
    width: '100%',
    zIndex: 850,
    '@media screen and (prefers-reduced-motion: reduce)': {
        transition: 'none',
    },
};
export var overlayOpen = {
    height: '100%',
    background: 'rgba(17, 30, 40, 0.5)',
};
export var overlayOpenBody = {
    overflow: 'hidden',
};
export var drawerHeader = {
    position: 'relative',
    zIndex: 901,
    borderBottom: "1px solid ".concat('#E6EEF5'),
    boxShadow: '0px 4px 12px rgba(166, 176, 186, 0.4)',
};
export var headerWrapperOverride = {
    '.citron-header-wrapper': {
        border: 'none',
    },
};
export var drawerHeaderNested = {
    position: 'relative',
    zIndex: 903,
    boxShadow: '0px 4px 12px rgba(166, 176, 186, 0.4)',
};
export var subHeader = {
    width: 'inherit',
    padding: "".concat(12, "px ").concat(16, "px"),
    backgroundColor: '#f5f5f5',
    height: 'auto',
};
